const AverageFn = ({ values }) => {
  let sum = 0
  let count = 0
  let avg = null

  values.forEach(value => {
    const groupNode =
      value !== null && value !== undefined && typeof value === 'object'
    if (groupNode) {
      sum += value.avg * value.count
      count += value.count
    } else {
      if (typeof value === 'number' && value !== 0) {
        sum += value
        count++
      }
    }
  })
  if (count !== 0) {
    avg = sum / count
  } else {
    avg = null
  }
  return avg
}

const VariesFn = ({ values }) => {
  let count = 0
  let val = null
  let varies = false
  let result = null

  values.forEach(value => {
    if (count === 0) {
      val = value
    }
    const groupNode =
      value !== null && value !== undefined && typeof value === 'object'
    if (groupNode) {
      varies = value.varies
      count += value.count
    } else {
      if (typeof value === 'number') {
        if (val !== value) {
          varies = true
        }
        count++
      }
    }
  })
  if (count !== 0) {
    if (varies) {
      result = 'Varies'
    } else {
      result = val
    }
  } else {
    result = null
  }
  return result
}

const avgCostRetailFn = ({ values }) => {
  let totalCostRetailSum = 0
  let unitsSum = 0
  values.forEach(value => {
    if ((value?.totalCostRetail ?? 0) !== 0) {
      totalCostRetailSum += value.totalCostRetail
    }
    if ((value?.units ?? 0) !== 0) {
      unitsSum += value.units
    }
  })
  return createAvgValueObject(totalCostRetailSum, unitsSum)
}

const aggMarkUpFn = ({ values }) => {
  let totalCostSum = 0
  let totalRetailSum = 0
  values.forEach(value => {
    if ((value?.totalCost ?? 0) !== 0) {
      totalCostSum += value.totalCost
    }
    if ((value?.totalRetail ?? 0) !== 0) {
      totalRetailSum += value.totalRetail
    }
  })
  return createMarkUpValueObject(totalCostSum, totalRetailSum)
}

export const createAvgValueObject = (totalCostRetail = 0, units = 0) => {
  return {
    totalCostRetail,
    units,
    toString: () => (units !== 0 ? totalCostRetail / units : 0),
  }
}

export const createMarkUpValueObject = (totalCost = 0, totalRetail = 0) => {
  return {
    totalCost,
    totalRetail,
    toString: () =>
      totalRetail !== 0 ? (1 - totalCost / totalRetail) * 100 : 0,
  }
}

export { AverageFn, VariesFn, avgCostRetailFn, aggMarkUpFn }
